import type { ConsentStrategy } from './ConsentStrategy';

declare global {
  interface Window {
    /** consentmanager.app's banner instance — third-party, narrowed at runtime. */
    __consentManager?: unknown;
  }
}

/**
 * `__consentManager` is a generic name another script could own, so the CMP only counts as
 * present once the global carries consentmanager.app's `hasConsent` method.
 */
function readHasConsent(): ((category: string) => unknown) | null {
  const manager = window.__consentManager;
  if (typeof manager !== 'object' || manager === null) {
    return null;
  }

  const hasConsent = (manager as { hasConsent?: unknown }).hasConsent;

  return typeof hasConsent === 'function' ? (hasConsent as (category: string) => unknown).bind(manager) : null;
}

/**
 * consentmanager.app (a different product from consentmanager.net) has a fixed category set —
 * necessary, functional, analytics, marketing — and BirdsView is behavioural analytics. Its
 * consent starts all-false until the stored choice is restored, which is the correct closed
 * state, so there is no separate "not answered yet" case.
 */
export class ConsentmanagerAppStrategy implements ConsentStrategy {
  readonly name = 'consentmanager-app';

  isPresent(): boolean {
    return readHasConsent() !== null;
  }

  hasConsent(): boolean {
    return readHasConsent()?.('analytics') === true;
  }
}
